import type { AppComponentItem } from '~/types/common/item'

/**
 * 将nuxtui导航菜单项，格式化为通用组件数据
 * @param navIndex 导航菜单索引
 * @returns 导航菜单项数组
 */
export function useNavMenuItem(navIndex: number): AppComponentItem[] {
  const { appMenu } = useConfigMenu()
  return (
    appMenu.value[navIndex]?.children?.map(item => ({
      label: item.label,
      value: item.to,
    })) || []
  )
}
